// extracted by mini-css-extract-plugin
export var active = "unit-module--active--fd6b8";
export var amenitiesWrapper = "unit-module--amenitiesWrapper--30fda";
export var applyNow = "unit-module--applyNow--b12d0";
export var backButton = "unit-module--backButton--6e6c2";
export var bannerCarousel = "unit-module--bannerCarousel--134c2";
export var carousel = "unit-module--carousel--db0f1";
export var container = "unit-module--container--14340";
export var controls = "unit-module--controls--d5536";
export var decor = "unit-module--decor--f6af9";
export var detailsContainer = "unit-module--detailsContainer--ec027";
export var detailsControls = "unit-module--detailsControls--0c574";
export var hidden = "unit-module--hidden--3e923";
export var image = "unit-module--image--e1b19";
export var inner = "unit-module--inner--6d12e";
export var line = "unit-module--line--3b64f";
export var mediaContainer = "unit-module--mediaContainer--0350d";
export var mediaControls = "unit-module--mediaControls--306c3";
export var mobileCounter = "unit-module--mobileCounter--e2579";
export var nextButton = "unit-module--nextButton--16b53";
export var noTour = "unit-module--noTour--a30c9";
export var overlay = "unit-module--overlay--b7d91";
export var priceContainer = "unit-module--priceContainer--a6f4f";
export var relativeWrapper = "unit-module--relativeWrapper--9e5fa";
export var shareContainer = "unit-module--shareContainer--27eab";
export var sharing = "unit-module--sharing--5fa45";
export var sideLine = "unit-module--sideLine--9df55";
export var toggle = "unit-module--toggle--6eef9";
export var unitDetails = "unit-module--unitDetails--e7782";